/* eslint no-eval: 0 */
import React, {useState} from 'react'
import words from 'lodash.words'
import Numbers from './components/Numbers'
import Functions from './components/Functions'
import MathOperations from './components/MathOperations'
import Result from './components/Result'
import './App.css'


// Función Flecha o Arrow Function
const App = () => {
    const [stack, setStack] = useState("");
    //const texto = arrayTextoFuncionModificaText[0];
    //const funcionModificaTexto = arrayTextoFuncionModificaText[1];
    const items = words(stack, /[^-^+^*^/]+/g);
    const value = items.length > 0 ? items[items.length-1] : "0";

    const clickHandlerFunction = (stack) => {
        console.log("Button.clickHandler1", stack)
    }

    // Lo que ejecuta la función
    console.log("Renderización de App")
    return (
    <main className='react-calculator'>
        <Result value={value} />
        <Numbers onClickNumber={number => {
            setStack(`${stack}${number}`)
        }}/> 
        <Functions 
            onContentClear={() => { 
                console.log("Content Clear")
                setStack("") 
            }}
                
            onDelete={() => {
                console.log("onDelete")
                if(stack.length > 0){
                    const newStack = stack.substring(0, stack.length - 1)
                    setStack(newStack)
                }
            }}
        />
        <MathOperations 
            onClickOperation={operation => {
                console.log("Operation:", operation)
                setStack(`${stack}${operation}`)
            }}
            onClickEqual={equal => {
                console.log("Equal:", equal)
                setStack(eval(stack).toString())
            }}

        />
    </main>)
}

export default App

